// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Magnific Popup CSS */
.mfp-bg {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1042;
  overflow: hidden;
  position: fixed;
  background: #0b0b0b;
  opacity: 0.8; }

.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  outline: none !important;
  -webkit-backface-visibility: hidden; }

.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  box-sizing: border-box; }

.mfp-container:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle; }

.mfp-align-top .mfp-container:before {
  display: none; }

.mfp-content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  z-index: 1045; }

.mfp-inline-holder .mfp-content,
.mfp-ajax-holder .mfp-content {
  width: 100%;
  cursor: auto; }

.mfp-ajax-cur {
  cursor: progress; }

.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {
  cursor: zoom-out; }

.mfp-zoom {
  cursor: pointer;
  cursor: zoom-in; }

.mfp-auto-cursor .mfp-content {
  cursor: auto; }

.mfp-close,
.mfp-arrow,
.mfp-preloader,
.mfp-counter {
  -webkit-user-select: none;
  user-select: none; }

.mfp-loading.mfp-figure {
  display: none; }

.mfp-hide {
  display: none !important; }

.mfp-preloader {
  color: #CCC;
  position: absolute;
  top: 50%;
  width: auto;
  text-align: center;
  margin-top: -0.8em;
  left: 8px;
  right: 8px;
  z-index: 1044; }
  .mfp-preloader a {
    color: #CCC; }
    .mfp-preloader a:hover {
      color: #FFF; }

.mfp-s-ready .mfp-preloader {
  display: none; }

.mfp-s-error .mfp-content {
  display: none; }

button.mfp-close,
button.mfp-arrow {
  overflow: visible;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: none;
  padding: 0;
  z-index: 1046;
  box-shadow: none;
  touch-action: manipulation; }

button::-moz-focus-inner {
  padding: 0;
  border: 0; }

.mfp-close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  opacity: 0.65;
  padding: 0 0 18px 10px;
  color: #FFF;
  font-style: normal;
  font-size: 28px;
  font-family: Arial, Baskerville, monospace; }
  .mfp-close:hover,
  .mfp-close:focus {
    opacity: 1; }
  .mfp-close:active {
    top: 1px; }

.mfp-close-btn-in .mfp-close {
  color: #333; }

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
  color: #FFF;
  right: -6px;
  text-align: right;
  padding-right: 6px;
  width: 100%; }

.mfp-counter {
  position: absolute;
  top: 0;
  right: 0;
  color: #CCC;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap; }

.mfp-arrow {
  position: absolute;
  opacity: 0.65;
  margin: 0;
  top: 50%;
  margin-top: -55px;
  padding: 0;
  width: 90px;
  height: 110px;
  -webkit-tap-highlight-color: transparent; }
  .mfp-arrow:active {
    margin-top: -54px; }
  .mfp-arrow:hover,
  .mfp-arrow:focus {
    opacity: 1; }
  .mfp-arrow:before,
  .mfp-arrow:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 35px;
    margin-left: 35px;
    border: medium inset transparent; }
  .mfp-arrow:after {
    border-top-width: 13px;
    border-bottom-width: 13px;
    top: 8px; }
  .mfp-arrow:before {
    border-top-width: 21px;
    border-bottom-width: 21px;
    opacity: 0.7; }

.mfp-arrow-left {
  left: 0; }
  .mfp-arrow-left:after {
    border-right: 17px solid #FFF;
    margin-left: 31px; }
  .mfp-arrow-left:before {
    margin-left: 25px;
    border-right: 27px solid #3F3F3F; }

.mfp-arrow-right {
  right: 0; }
  .mfp-arrow-right:after {
    border-left: 17px solid #FFF;
    margin-left: 39px; }
  .mfp-arrow-right:before {
    border-left: 27px solid #3F3F3F; }

.mfp-iframe-holder {
  padding-top: 40px;
  padding-bottom: 40px; }
  .mfp-iframe-holder .mfp-content {
    line-height: 0;
    width: 100%;
    max-width: 900px; }
  .mfp-iframe-holder .mfp-close {
    top: -40px; }

.mfp-iframe-scaler {
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%; }
  .mfp-iframe-scaler iframe {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #000; }

/* Main image in popup */
img.mfp-img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  box-sizing: border-box;
  padding: 40px 0 40px;
  margin: 0 auto; }

/* The shadow behind the image */
.mfp-figure {
  line-height: 0; }
  .mfp-figure:after {
    content: '';
    position: absolute;
    left: 0;
    top: 40px;
    bottom: 40px;
    display: block;
    right: 0;
    width: auto;
    height: auto;
    z-index: -1;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #444; }
  .mfp-figure small {
    color: #BDBDBD;
    display: block;
    font-size: 12px;
    line-height: 14px; }
  .mfp-figure figure {
    margin: 0; }

.mfp-bottom-bar {
  margin-top: -36px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  cursor: auto; }

.mfp-title {
  text-align: left;
  line-height: 18px;
  color: #F3F3F3;
  word-wrap: break-word;
  padding-right: 36px; }

.mfp-image-holder .mfp-content {
  max-width: 100%; }

.mfp-gallery .mfp-image-holder .mfp-figure {
  cursor: pointer; }

@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {
  /**
       * Remove all paddings around the image on small screen
       */
  .mfp-img-mobile .mfp-image-holder {
    padding-left: 0;
    padding-right: 0; }
  .mfp-img-mobile img.mfp-img {
    padding: 0; }
  .mfp-img-mobile .mfp-figure:after {
    top: 0;
    bottom: 0; }
  .mfp-img-mobile .mfp-figure small {
    display: inline;
    margin-left: 5px; }
  .mfp-img-mobile .mfp-bottom-bar {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    margin: 0;
    top: auto;
    padding: 3px 5px;
    position: fixed;
    box-sizing: border-box; }
    .mfp-img-mobile .mfp-bottom-bar:empty {
      padding: 0; }
  .mfp-img-mobile .mfp-counter {
    right: 5px;
    top: 3px; }
  .mfp-img-mobile .mfp-close {
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    text-align: center;
    padding: 0; } }

@media all and (max-width: 900px) {
  .mfp-arrow {
    transform: scale(0.75); }
  .mfp-arrow-left {
    transform-origin: 0; }
  .mfp-arrow-right {
    transform-origin: 100%; }
  .mfp-container {
    padding-left: 6px;
    padding-right: 6px; } }
`, "",{"version":3,"sources":["webpack://./src/assets/css/magnific-popup.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAE;;AAEhB;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,mCAAmC,EAAE;;AAEvC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,cAAc;EACd,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,sBAAsB,EAAE;;AAE1B;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,aAAa,EAAE;;AAEjB;;EAEE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,gBAAgB,EAAE;;AAEpB;EAGE,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EAGf,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;;AAEhB;;;;EAIE,yBAAyB;EAEzB,iBAAiB,EAAE;;AAErB;EACE,aAAa,EAAE;;AAEjB;EACE,wBAAwB,EAAE;;AAE5B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa,EAAE;EACf;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;;EAEE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,0BAA0B,EAAE;;AAE9B;EACE,UAAU;EACV,SAAS,EAAE;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,0CAA0C,EAAE;EAC5C;;IAEE,UAAU,EAAE;EACd;IACE,QAAQ,EAAE;;AAEd;EACE,WAAW,EAAE;;AAEf;;EAEE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,aAAa;EACb,wCAAwC,EAAE;EAC1C;IACE,iBAAiB,EAAE;EACrB;;IAEE,UAAU,EAAE;EACd;;IAEE,WAAW;IACX,cAAc;IACd,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC,EAAE;EACpC;IACE,sBAAsB;IACtB,yBAAyB;IACzB,QAAQ,EAAE;EACZ;IACE,sBAAsB;IACtB,yBAAyB;IACzB,YAAY,EAAE;;AAElB;EACE,OAAO,EAAE;EACT;IACE,6BAA6B;IAC7B,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,gCAAgC,EAAE;;AAEtC;EACE,QAAQ,EAAE;EACV;IACE,4BAA4B;IAC5B,iBAAiB,EAAE;EACrB;IACE,+BAA+B,EAAE;;AAErC;EACE,iBAAiB;EACjB,oBAAoB,EAAE;EACtB;IACE,cAAc;IACd,WAAW;IACX,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;;AAEhB;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,gBAAgB,EAAE;;AAEtB,wBAAwB;AACxB;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,cAAc,EAAE;;AAElB,gCAAgC;AAChC;EACE,cAAc,EAAE;EAChB;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,SAAS,EAAE;;AAEf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE;;QAEM;EACN;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,UAAU,EAAE;EACd;IACE,MAAM;IACN,SAAS,EAAE;EACb;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,8BAA8B;IAC9B,SAAS;IACT,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAE;IACxB;MACE,UAAU,EAAE;EAChB;IACE,UAAU;IACV,QAAQ,EAAE;EACZ;IACE,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,UAAU,EAAE,EAAE;;AAElB;EACE;IAEE,sBAAsB,EAAE;EAC1B;IAEE,mBAAmB,EAAE;EACvB;IAEE,sBAAsB,EAAE;EAC1B;IACE,iBAAiB;IACjB,kBAAkB,EAAE,EAAE","sourcesContent":["/* Magnific Popup CSS */\r\n.mfp-bg {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1042;\r\n  overflow: hidden;\r\n  position: fixed;\r\n  background: #0b0b0b;\r\n  opacity: 0.8; }\r\n\r\n.mfp-wrap {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1043;\r\n  position: fixed;\r\n  outline: none !important;\r\n  -webkit-backface-visibility: hidden; }\r\n\r\n.mfp-container {\r\n  text-align: center;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  padding: 0 8px;\r\n  box-sizing: border-box; }\r\n\r\n.mfp-container:before {\r\n  content: '';\r\n  display: inline-block;\r\n  height: 100%;\r\n  vertical-align: middle; }\r\n\r\n.mfp-align-top .mfp-container:before {\r\n  display: none; }\r\n\r\n.mfp-content {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 auto;\r\n  text-align: left;\r\n  z-index: 1045; }\r\n\r\n.mfp-inline-holder .mfp-content,\r\n.mfp-ajax-holder .mfp-content {\r\n  width: 100%;\r\n  cursor: auto; }\r\n\r\n.mfp-ajax-cur {\r\n  cursor: progress; }\r\n\r\n.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {\r\n  cursor: -moz-zoom-out;\r\n  cursor: -webkit-zoom-out;\r\n  cursor: zoom-out; }\r\n\r\n.mfp-zoom {\r\n  cursor: pointer;\r\n  cursor: -webkit-zoom-in;\r\n  cursor: -moz-zoom-in;\r\n  cursor: zoom-in; }\r\n\r\n.mfp-auto-cursor .mfp-content {\r\n  cursor: auto; }\r\n\r\n.mfp-close,\r\n.mfp-arrow,\r\n.mfp-preloader,\r\n.mfp-counter {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none; }\r\n\r\n.mfp-loading.mfp-figure {\r\n  display: none; }\r\n\r\n.mfp-hide {\r\n  display: none !important; }\r\n\r\n.mfp-preloader {\r\n  color: #CCC;\r\n  position: absolute;\r\n  top: 50%;\r\n  width: auto;\r\n  text-align: center;\r\n  margin-top: -0.8em;\r\n  left: 8px;\r\n  right: 8px;\r\n  z-index: 1044; }\r\n  .mfp-preloader a {\r\n    color: #CCC; }\r\n    .mfp-preloader a:hover {\r\n      color: #FFF; }\r\n\r\n.mfp-s-ready .mfp-preloader {\r\n  display: none; }\r\n\r\n.mfp-s-error .mfp-content {\r\n  display: none; }\r\n\r\nbutton.mfp-close,\r\nbutton.mfp-arrow {\r\n  overflow: visible;\r\n  cursor: pointer;\r\n  background: transparent;\r\n  border: 0;\r\n  -webkit-appearance: none;\r\n  display: block;\r\n  outline: none;\r\n  padding: 0;\r\n  z-index: 1046;\r\n  box-shadow: none;\r\n  touch-action: manipulation; }\r\n\r\nbutton::-moz-focus-inner {\r\n  padding: 0;\r\n  border: 0; }\r\n\r\n.mfp-close {\r\n  width: 44px;\r\n  height: 44px;\r\n  line-height: 44px;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  text-decoration: none;\r\n  text-align: center;\r\n  opacity: 0.65;\r\n  padding: 0 0 18px 10px;\r\n  color: #FFF;\r\n  font-style: normal;\r\n  font-size: 28px;\r\n  font-family: Arial, Baskerville, monospace; }\r\n  .mfp-close:hover,\r\n  .mfp-close:focus {\r\n    opacity: 1; }\r\n  .mfp-close:active {\r\n    top: 1px; }\r\n\r\n.mfp-close-btn-in .mfp-close {\r\n  color: #333; }\r\n\r\n.mfp-image-holder .mfp-close,\r\n.mfp-iframe-holder .mfp-close {\r\n  color: #FFF;\r\n  right: -6px;\r\n  text-align: right;\r\n  padding-right: 6px;\r\n  width: 100%; }\r\n\r\n.mfp-counter {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  color: #CCC;\r\n  font-size: 12px;\r\n  line-height: 18px;\r\n  white-space: nowrap; }\r\n\r\n.mfp-arrow {\r\n  position: absolute;\r\n  opacity: 0.65;\r\n  margin: 0;\r\n  top: 50%;\r\n  margin-top: -55px;\r\n  padding: 0;\r\n  width: 90px;\r\n  height: 110px;\r\n  -webkit-tap-highlight-color: transparent; }\r\n  .mfp-arrow:active {\r\n    margin-top: -54px; }\r\n  .mfp-arrow:hover,\r\n  .mfp-arrow:focus {\r\n    opacity: 1; }\r\n  .mfp-arrow:before,\r\n  .mfp-arrow:after {\r\n    content: '';\r\n    display: block;\r\n    width: 0;\r\n    height: 0;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    margin-top: 35px;\r\n    margin-left: 35px;\r\n    border: medium inset transparent; }\r\n  .mfp-arrow:after {\r\n    border-top-width: 13px;\r\n    border-bottom-width: 13px;\r\n    top: 8px; }\r\n  .mfp-arrow:before {\r\n    border-top-width: 21px;\r\n    border-bottom-width: 21px;\r\n    opacity: 0.7; }\r\n\r\n.mfp-arrow-left {\r\n  left: 0; }\r\n  .mfp-arrow-left:after {\r\n    border-right: 17px solid #FFF;\r\n    margin-left: 31px; }\r\n  .mfp-arrow-left:before {\r\n    margin-left: 25px;\r\n    border-right: 27px solid #3F3F3F; }\r\n\r\n.mfp-arrow-right {\r\n  right: 0; }\r\n  .mfp-arrow-right:after {\r\n    border-left: 17px solid #FFF;\r\n    margin-left: 39px; }\r\n  .mfp-arrow-right:before {\r\n    border-left: 27px solid #3F3F3F; }\r\n\r\n.mfp-iframe-holder {\r\n  padding-top: 40px;\r\n  padding-bottom: 40px; }\r\n  .mfp-iframe-holder .mfp-content {\r\n    line-height: 0;\r\n    width: 100%;\r\n    max-width: 900px; }\r\n  .mfp-iframe-holder .mfp-close {\r\n    top: -40px; }\r\n\r\n.mfp-iframe-scaler {\r\n  width: 100%;\r\n  height: 0;\r\n  overflow: hidden;\r\n  padding-top: 56.25%; }\r\n  .mfp-iframe-scaler iframe {\r\n    position: absolute;\r\n    display: block;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\r\n    background: #000; }\r\n\r\n/* Main image in popup */\r\nimg.mfp-img {\r\n  width: auto;\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  line-height: 0;\r\n  box-sizing: border-box;\r\n  padding: 40px 0 40px;\r\n  margin: 0 auto; }\r\n\r\n/* The shadow behind the image */\r\n.mfp-figure {\r\n  line-height: 0; }\r\n  .mfp-figure:after {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 40px;\r\n    bottom: 40px;\r\n    display: block;\r\n    right: 0;\r\n    width: auto;\r\n    height: auto;\r\n    z-index: -1;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\r\n    background: #444; }\r\n  .mfp-figure small {\r\n    color: #BDBDBD;\r\n    display: block;\r\n    font-size: 12px;\r\n    line-height: 14px; }\r\n  .mfp-figure figure {\r\n    margin: 0; }\r\n\r\n.mfp-bottom-bar {\r\n  margin-top: -36px;\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n  cursor: auto; }\r\n\r\n.mfp-title {\r\n  text-align: left;\r\n  line-height: 18px;\r\n  color: #F3F3F3;\r\n  word-wrap: break-word;\r\n  padding-right: 36px; }\r\n\r\n.mfp-image-holder .mfp-content {\r\n  max-width: 100%; }\r\n\r\n.mfp-gallery .mfp-image-holder .mfp-figure {\r\n  cursor: pointer; }\r\n\r\n@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {\r\n  /**\r\n       * Remove all paddings around the image on small screen\r\n       */\r\n  .mfp-img-mobile .mfp-image-holder {\r\n    padding-left: 0;\r\n    padding-right: 0; }\r\n  .mfp-img-mobile img.mfp-img {\r\n    padding: 0; }\r\n  .mfp-img-mobile .mfp-figure:after {\r\n    top: 0;\r\n    bottom: 0; }\r\n  .mfp-img-mobile .mfp-figure small {\r\n    display: inline;\r\n    margin-left: 5px; }\r\n  .mfp-img-mobile .mfp-bottom-bar {\r\n    background: rgba(0, 0, 0, 0.6);\r\n    bottom: 0;\r\n    margin: 0;\r\n    top: auto;\r\n    padding: 3px 5px;\r\n    position: fixed;\r\n    box-sizing: border-box; }\r\n    .mfp-img-mobile .mfp-bottom-bar:empty {\r\n      padding: 0; }\r\n  .mfp-img-mobile .mfp-counter {\r\n    right: 5px;\r\n    top: 3px; }\r\n  .mfp-img-mobile .mfp-close {\r\n    top: 0;\r\n    right: 0;\r\n    width: 35px;\r\n    height: 35px;\r\n    line-height: 35px;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    position: fixed;\r\n    text-align: center;\r\n    padding: 0; } }\r\n\r\n@media all and (max-width: 900px) {\r\n  .mfp-arrow {\r\n    -webkit-transform: scale(0.75);\r\n    transform: scale(0.75); }\r\n  .mfp-arrow-left {\r\n    -webkit-transform-origin: 0;\r\n    transform-origin: 0; }\r\n  .mfp-arrow-right {\r\n    -webkit-transform-origin: 100%;\r\n    transform-origin: 100%; }\r\n  .mfp-container {\r\n    padding-left: 6px;\r\n    padding-right: 6px; } }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
